import { APP_ID, computed, inject, Signal } from '@angular/core';
import { Product, ProductService } from 'product-shared';
import { Promotion } from 'promotion-shared';
import { TranslateService } from 'translate';
import { App } from 'utils';

export class ProductBoxBase {
  private appId = inject(APP_ID);
  protected translateService = inject(TranslateService);
  protected productService = inject(ProductService);
  protected product: Signal<Product>;
  protected promotion: Signal<Promotion>;
  protected hasDiscountedCost = computed(() => this.discountedPrice() < this.product()?.monthly_cost);
  protected promotionBannerText = computed(
    () =>
      this.product()?.promotion_banner_text ||
      this.promotion().title ||
      `${Promotion.discountPercentage(
        Number(this.product()?.monthly_cost),
        this.promotion().discountAmount
      )}% ${this.translateService.getTranslation(['discount'])}`
  );
  protected discountedPrice = computed(() => this.product()?.discountedPrice(this.promotion()?.discountAmount));
  protected discountPercentage = computed(() =>
    this.productService.getDiscountPercentage(this.product()?.monthly_cost, this.promotion()?.discountAmount)
  );
  protected activationFee = computed(() => {
    if (typeof this.promotion()?.activationFeeDiscount !== 'undefined') {
      return this.product()?.activation_fee - this.promotion().activationFeeDiscount;
    }

    return this.product()?.activation_fee;
  });
  protected contractDuration = computed(() => {
    if (!this.promotion()?.lockinLengths?.length && !this.product()?.lockin_length?.length) {
      return;
    }
    return this.productService.contractDuration(this.promotion()?.lockinLengths, this.product()?.lockin_length);
  });
  protected chipsLabelsKeys = computed(() =>
    this.productService.getChipsLabelsKeys(
      !!this.promotion(),
      this.hasDiscountedCost(),
      this.activationFee(),
      this.contractDuration()
    )
  );
  protected enablePromotionOverride = this.appId === App.pos;
}
